import { Link } from 'react-router-dom';

const MskKnowledgeAiHero = () => {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden bg-[#F8FBF6]">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-[#89B56B]"></div>
        <div className="absolute bottom-10 right-20 w-48 h-48 rounded-full bg-[#5DAA68]"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 rounded-full bg-[#3F6844]"></div>
      </div>
      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="mb-6">
              <img
                src="/image/msk-knowledge-ai-logo.png"
                alt="MSK AIアシスタント ロゴ"
                className="w-20 h-20 mx-auto lg:mx-0 object-contain rounded-xl"
              />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-[#89B56B] font-['Noto_Sans_JP'] mb-2">
              MSK AIアシスタント
            </h1>
            <p className="text-sm text-[#5DAA68] font-semibold tracking-wider mb-6 font-['Inter']">
              - Manual Support Knowledge -
            </p>
            <p className="text-[13px] text-gray-600 leading-relaxed mb-8 max-w-md mx-auto lg:mx-0">
              「24時間365日、社内外の『わからない』を即座に解決するAIパートナー」
              <br />
              テキストや仕様書のURLをナレッジとして登録するだけで、高精度なAIチャットボットを構築。
              <br />
              ユーザーや社員からの問い合わせ対応を自動化し、業務効率化を実現します。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="#usage"
                className="inline-flex items-center justify-center px-8 py-3.5 bg-[#89B56B] text-white text-sm font-bold rounded-lg hover:bg-[#5DAA68] transition-colors cursor-pointer whitespace-nowrap shadow-[0_4px_16px_rgba(137,181,107,0.3)]"
              >
                ご利用・ご相談にあたって
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-3.5 bg-white text-[#5DAA68] border border-[#5DAA68] text-sm font-bold rounded-lg hover:bg-[#89B56B] hover:text-white hover:border-[#89B56B] transition-colors cursor-pointer whitespace-nowrap"
              >
                お問い合わせ
              </Link>
            </div>
          </div>

          <div className="flex-1 max-w-md lg:max-w-lg">
            <div className="rounded-2xl overflow-hidden shadow-[0_8px_40px_rgba(0,0,0,0.15)] border border-gray-100">
              <img
                src="/image/msk-knowledge-ai.png"
                alt="MSK AIアシスタント デモ画面"
                title="MSK AIアシスタント - Manual Support Knowledge"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MskKnowledgeAiHero;
